import cn from 'classnames';
import { HEADER_HEIGHT } from 'src/constants/common';
import { useRubrics } from 'src/hooks/news';

import { Space, Typography, Button, Icon, Grid } from '@sravni/react-design-system';
import { Cross } from '@sravni/react-icons';

import { RubricMenuSearch } from '../../../SearchBlock';

import { FormatsMenu } from './components/FormatsMenu';
import { Item } from './components/Item';
import styles from './customdialogrubricmenu.module.scss';

interface Props {
  view: boolean;
  closeView: () => void;
  subscriptionPopupState: [number, (value: number) => void];
}

export const CustomDialogRubricMenu = ({ view, closeView, subscriptionPopupState }: Props) => {
  const rubrics = useRubrics();

  return (
    <>
      <div onClick={closeView} className={cn(styles.closeWrapper, { [styles['closeWrapper--visible']]: view })}></div>
      <div
        style={{ top: -HEADER_HEIGHT, height: `calc(100vh + ${HEADER_HEIGHT}px)`, paddingTop: HEADER_HEIGHT }}
        className={cn(styles.dialog, { [styles['dialog--visible']]: view })}
      >
        <Space direction="vertical" size={16} className={styles.wrapper} justify="space-between">
          <Space direction="vertical" size={16} className={styles.scrollBlockMenu}>
            <Space>
              <Typography.Heading level={3}>Журнал Сравни</Typography.Heading>
            </Space>
            <Space direction="horizontal" size={32} className={styles.scrollBlockMenu}>
              <Space direction="vertical">
                <FormatsMenu subscriptionPopupState={subscriptionPopupState} hideMenuController={closeView} />
              </Space>
              <Space direction="vertical">
                {rubrics?.map((item) => (
                  <Item item={item} closeView={closeView} />
                ))}
              </Space>
            </Space>
          </Space>
          <Space direction="vertical">
            <Grid.Row gutter={[20, 20]}>
              <Grid.Col span={2} className={styles.col}>
                <Button onClick={closeView} className={styles.closeButton} size={52} color="blue" variant="outlined">
                  <Icon icon={<Cross />} />
                </Button>
              </Grid.Col>
              <Grid.Col span={10} className={styles.col}>
                <RubricMenuSearch toogleRubricMenu={closeView} />
              </Grid.Col>
            </Grid.Row>
          </Space>
        </Space>
      </div>
    </>
  );
};
